var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-3 py-2" },
    [
      _c(
        "v-client-table",
        {
          ref: "tableComponent",
          staticClass: "jTable",
          attrs: {
            columns: _vm.columns,
            data: _vm.dataTable,
            options: _vm.table_options
          },
          scopedSlots: _vm._u([
            {
              key: "name",
              fn: function(props) {
                return _c("div", {}, [
                  _vm._v("\n      " + _vm._s(props.row.index_name) + "\n    ")
                ])
              }
            },
            {
              key: "definition",
              fn: function(props) {
                return _c(
                  "div",
                  { staticClass: "wrap-definition" },
                  _vm._l(props.row.keys, function(key) {
                    return _c(
                      "div",
                      { key: key.id, staticClass: "definition" },
                      [
                        _c("span", [_vm._v(_vm._s(key.column))]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/icon/" +
                              (key.type === "ascending" ? "asc" : "desc") +
                              ".svg"),
                            alt: key.column.id
                          }
                        })
                      ]
                    )
                  })
                )
              }
            },
            {
              key: "action",
              fn: function(props) {
                return _vm.isAdmin
                  ? _c("div", {}, [
                      _c("i", {
                        staticClass: "fa fa-trash",
                        staticStyle: { "font-size": "16px" },
                        on: {
                          click: function($event) {
                            _vm.openModalDelete(props.row.index_name)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              }
            }
          ])
        },
        [
          _vm.isAdmin
            ? _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-form m__r--5",
                          on: { click: _vm.openModalAdd }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add Index\n        ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addIndexModal",
          staticClass: "modal-indexes",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalAdd
            ? _c("modal-add-indexes", {
                attrs: { columns: _vm.listColumns },
                on: {
                  "refresh-data": _vm.getDataIndexes,
                  "close-modal": _vm.closeModalAdd
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteIndexModal",
          staticClass: "modal-indexes",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalDelete
            ? _c("modal-delete-indexes", {
                attrs: { "indexes-name": _vm.indexesSelected },
                on: {
                  "refresh-data": _vm.getDataIndexes,
                  "close-modal": _vm.closeModalDelete
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-560e4c4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560e4c4f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetIndexes.vue
// module id = null
// module chunks = 